var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDifferent = function SvgDifferent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "different_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#different_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.656 5.938q.236-.578.806-.818t1.15-.002q.578.236.818.807.24.57.002 1.149l-.25.611H18.5q.625 0 1.063.438Q20 8.56 20 9.185t-.437 1.063a1.45 1.45 0 0 1-1.063.437h-3.544l-1.636 4h5.18q.625 0 1.063.438.437.437.437 1.062t-.437 1.063a1.45 1.45 0 0 1-1.063.437h-6.406l-.581 1.422a1.45 1.45 0 0 1-.807.818q-.57.24-1.15.003a1.45 1.45 0 0 1-.817-.808q-.24-.57-.003-1.149l.117-.286H5.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 4 16.185q0-.624.438-1.062a1.45 1.45 0 0 1 1.062-.438h4.58l1.635-4H5.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 4 9.185q0-.624.438-1.062A1.45 1.45 0 0 1 5.5 7.685h7.441z"
  }))));
};
export default SvgDifferent;